import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { Directive, HostListener, Inject, Input, inject } from '@angular/core';
import { WINDOW } from '../../app.module';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Directive({
 selector: '[ihoDatepicker]',
 standalone: true,
})
export class DatepickerDirective {
 autocompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);

 @Input() isMobile: boolean = false;
 @Input() allowToShow: boolean = true;
 @Input() reservable: boolean = false;
 @Input() ecolodePdp?: boolean = false;

 constructor(@Inject(WINDOW) private window: Window) {
 
 }

 @HostListener('click', ['$event']) onClick() {

  if (this.isMobile) {
   this.autocompleteService.setIsMobile(true);
   this.datepickerService.setIsMobile(true);
  }


  this.datepickerService.reservable.set(this.reservable);
  this.datepickerService.setState(true);
  this.datepickerService.setAllowToShow(this.allowToShow);
 }

}
